/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "FileVideoUpload"
  }, [_c('div', {
    staticClass: "default-add",
    on: {
      "click": _vm.clickUpload
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/addpic40_40@3x.png"
    }
  })]), _c('div', [_c('input', {
    ref: "photo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('input', {
    ref: "video",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "video/*",
      "capture": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "*/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };